import { NavLink } from "react-router-dom";
import { useTheme } from "@mui/material";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useStudioUsersCount } from "../../../components/hooks/useStudioUsersCount";
import DSCard from "views/system-design/DSCard";
import DSCardContent from "views/system-design/DSCardContent";
import DSBox from "views/system-design/DSBox";
import DSStack from "views/system-design/DSStack";
import DSTypography from "views/system-design/DSTypography";
import DSCircularProgress from "views/system-design/DSCircularProgress";

function StudioUsersWidget() {
  const theme = useTheme();
  const { data: studioUsersStats } = useStudioUsersCount();

  return (
    <DSCard sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <DSBox sx={{ px: 2, pt: 2 }}>
        <DSStack direction="row" alignItems="center" spacing={1.5}>
          <PersonOutlineOutlinedIcon
            sx={{ fontSize: "2rem", color: "#2196F3" }}
          />
          <DSBox>
            <DSTypography
              variant="body2"
              sx={{ color: "text.secondary", m: 0 }}
            >
              Studio Users
            </DSTypography>
            <DSTypography variant="h6" sx={{ m: 0 }}>
              <NavLink
                to="/admin/users"
                onClick={() =>
                  localStorage.setItem(
                    "userssearch",
                    "filter=studioContract.accepted",
                  )
                }
              >
                {studioUsersStats?.total ?? <DSCircularProgress size={20} />}
              </NavLink>
            </DSTypography>
          </DSBox>
        </DSStack>
      </DSBox>
      <DSCardContent sx={{ flex: 1 }}>
        {!studioUsersStats ? (
          <DSBox sx={{ textAlign: "center", p: "20px" }}>
            <DSCircularProgress />
          </DSBox>
        ) : studioUsersStats.daily.length ? (
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={studioUsersStats.daily} margin={{ left: 0 }}>
              <XAxis
                dataKey="date"
                tick={{ fontSize: 10, fill: theme.palette.text.secondary }}
                stroke={theme.palette.white[24]}
                tickFormatter={(d: string) => d.slice(5)}
              />
              <YAxis
                tick={{ fontSize: 10, fill: theme.palette.text.secondary }}
                stroke={theme.palette.white[24]}
                allowDecimals={false}
                width={30}
              />
              <Tooltip
                labelFormatter={(d) => d}
                formatter={(v) => [v, "joined"]}
                contentStyle={{
                  backgroundColor: theme.palette.paper.elevation8,
                  border: "none",
                  borderRadius: 8,
                }}
                cursor={{ fill: theme.palette.white[12] }}
              />
              <Bar
                dataKey="count"
                fill={theme.palette.primary.main}
                radius={[3, 3, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <DSBox
            sx={{ textAlign: "center", p: "20px", color: "text.secondary" }}
          >
            No joins in the last 30 days
          </DSBox>
        )}
      </DSCardContent>
      <DSBox
        sx={{ borderTop: `1px solid ${theme.palette.divider}`, px: 2, py: 1.5 }}
      >
        <DSTypography variant="caption" sx={{ color: "text.secondary" }}>
          Last 30 days
        </DSTypography>
      </DSBox>
    </DSCard>
  );
}

export default StudioUsersWidget;
